import { ExternalLink, Menu, X } from "lucide-react";
import { useEffect, useState } from "react";
import { slideDeckUrl } from "../../lib/links";
import { Brand } from "../ui/Brand";

const links = [
  { label: "Beranda", href: "#beranda" },
  { label: "Cara kerja", href: "#cara-kerja" },
  { label: "Demo chat", href: "#demo-chat" },
  { label: "Dashboard", href: "#dashboard" },
  { label: "Contoh website", href: "#contoh" },
  { label: "Paket", href: "#paket" },
  { label: "FAQ", href: "#faq" },
];

const blankLinkProps = { target: "_blank" as const, rel: "noopener noreferrer" };

export function LandingNavbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 24);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className={`fixed inset-x-0 top-1 z-50 transition-all duration-300 ${scrolled ? "px-3 pt-2 sm:px-6" : "px-3 pt-3 sm:px-6 sm:pt-4"}`}>
      <div className={`mx-auto max-w-[1380px] rounded-[1.25rem] border px-4 transition-all duration-300 sm:px-5 ${scrolled ? "border-white/80 bg-white/92 py-2 shadow-[0_18px_60px_rgba(15,45,27,.12)] backdrop-blur-2xl" : "border-transparent bg-white/70 py-3 backdrop-blur-xl"}`}>
        <div className="flex items-center justify-between gap-4">
          <Brand className="[&_img]:!h-10 sm:[&_img]:!h-11" />

          <nav className="hidden items-center gap-1 lg:flex">
            {links.map((link) => (
              <a key={link.href} href={link.href} className="rounded-xl px-3 py-2 text-sm font-extrabold text-slate-600 hover:bg-brand-50 hover:text-brand-700">
                {link.label}
              </a>
            ))}
          </nav>

          <div className="hidden items-center md:flex">
            <a href={slideDeckUrl} {...blankLinkProps} className="inline-flex items-center gap-2 rounded-xl bg-brand-600 px-4 py-2.5 text-sm font-black text-white shadow-lg shadow-brand-600/20 hover:-translate-y-0.5 hover:bg-brand-700">
              <ExternalLink size={17} /> Lihat Slide Deck
            </a>
          </div>

          <button type="button" onClick={() => setOpen((value) => !value)} className="grid h-10 w-10 place-items-center rounded-xl border border-slate-200 bg-white text-slate-700 md:hidden" aria-label="Buka menu" aria-expanded={open}>
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>

        {open && (
          <div className="mt-3 border-t border-slate-100 pt-3 md:hidden">
            <nav className="grid gap-1">
              {links.map((link) => (
                <a key={link.href} href={link.href} onClick={() => setOpen(false)} className="rounded-xl px-3 py-2.5 text-sm font-bold text-slate-600 hover:bg-brand-50 hover:text-brand-700">{link.label}</a>
              ))}
            </nav>
            <div className="mt-3">
              <a href={slideDeckUrl} {...blankLinkProps} onClick={() => setOpen(false)} className="btn-primary w-full !rounded-xl"><ExternalLink size={17} /> Lihat Slide Deck</a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
